module.exports = __webpack_public_path__ + "img/clock.e27ddb85.svg";